import { createSelector } from 'reselect';
import ComplianceReceptacleIdVsDespatchIdSubclassMismatchColumns from '../../containers/ComplianceReceptacleIdVsDespatchIdSubclassMismatchColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state.reporting.MISMATCHED_SUBCLASS_RECEPTACLE_ID_VS_DESPATCH_ID.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.MISMATCHED_SUBCLASS_RECEPTACLE_ID_VS_DESPATCH_ID.isLoading;

export const getData =
  ReportDefinitions.MISMATCHED_SUBCLASS_RECEPTACLE_ID_VS_DESPATCH_ID.getDataFunction();

export const getColumns =
  createSelector(getData, ComplianceReceptacleIdVsDespatchIdSubclassMismatchColumns);
